// sub menu active class added
(($) => {
	$(() => {
		const mainType = $('main').attr('data-cat');

		const subMenuItems = $('#mega-menu-main-menu .mega-menu-link');
		if (subMenuItems.length > 0) {
			subMenuItems.each((i, el) => {
				if (mainType !== null && $(el).parent().hasClass(mainType)) {
					$(el).closest('.mega-menu-item').addClass('mega-current-menu-item');
				}
			});
		}

		const footerSubMenuList = $('.footer__menus .menu-item');
		if (footerSubMenuList.length > 0) {
			footerSubMenuList.each((i, el) => {
				if (mainType !== null && $(el).hasClass(mainType)) {
					$(el).addClass('current-menu-item');
					$(el).addClass('current_page_item');
				}
			});
		}
	});
})(jQuery);
